module.exports = __webpack_public_path__ + "img/img-17.2a9c67bd.png";